export function formatCurrency (price) {
  const formatMoneyFunction = window.theme.Currency.formatMoney
  const moneyFormat = window.theme.settings.moneyFormat
  return formatMoneyFunction(price, moneyFormat)
}

export function priceString (variant) {
  if (!variant || !variant.price) {
    return ''
  }
  const variantPrice = (variant.price / 100).toFixed(2)
  const regularPrice = formatCurrency(variantPrice)
  const discount = variant.compare_at_price !== null ? `
  <span class="price__discount">
    <strike>
      ${formatCurrency((variant.compare_at_price / 100).toFixed(2))}
    </strike>
  </span>` : ''
  return `${regularPrice}${discount}`
}

export function getPriceSection () {
  let priceSection = ''
  if (!window.theme.productData || !window.theme.productData.variants || !window.theme.productData.variants.length) {
    return priceSection
  }
  window.theme.productData.variants.forEach((variant) => {
    priceSection += `<p class="price__main">${priceString(variant)}</p>`
  })
  priceSection = `<div class='price__section'>${priceSection}</div>`

  return priceSection
}
